import React from "react";
import uuid from "uuid/v4";
import Sheet from "./sheet";

class Excel extends React.Component {
  state = {
    data: []
  };

  onChange = (arr, firstRow) => {
    let newData = {};
    arr.map(item => {
      newData = {
        ...newData,
        [uuid()]: {
          ...item
        }
      };
      return newData;
    });
    this.setState({ data: arr, firstRow });
  };

  render() {
    return <Sheet onChange={this.onChange} />;
  }
}

export default Excel;
